import {
    REQUEST_USER_IDENTITY_VERIFIED,
    RECEIVE_USER_IDENTITY_VERIFIED,
    FAILURE_USER_IDENTITY_VERIFIED
} from './constants';

import { CALL_API } from '../../../middlewares/api';

export function fetchIsIdentityVerified() {
    return {
        [CALL_API]: {
            endpoint: '/user/identity-verified',
            types: [
                REQUEST_USER_IDENTITY_VERIFIED,
                RECEIVE_USER_IDENTITY_VERIFIED,
                FAILURE_USER_IDENTITY_VERIFIED
            ]
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/account/identity/actions.js